module.exports = __webpack_public_path__ + "img/empty.b7f962e5.png";